import { EventEmitter, Injectable } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})

export class LocationCategoryService {

  is_display_location_category_register_component = false;
  LocationCategoryUpdate = new EventEmitter<ZONE>();
  downloadLocationCategory = new EventEmitter<boolean>();

  private _location_category_data: LOCATIONCATEGORY = null;
  constructor() { }

  set set_location_category_data(loc_category) {
    this._location_category_data = loc_category;
  }

  get get_location_category_data() {
    return this._location_category_data;
  }
}

export interface LOCATIONCATEGORY {
  id: number;
  name: string;
}
